/**
* กรุงเทพมหานคร — สำนักงานใหญ่ + ย่านศูนย์กลางธุรกิจ + ครบ 50 เขต
*/
import { branch, type Branch } from "./types";

export const BANGKOK_BRANCHES: Branch[] = [
  branch({
    id: "bkk-hq-wang-thonglang",
    name: "สำนักงานใหญ่ กรุงเทพมหานคร (วังทองหลาง)",
    shortName: "สำนักงานใหญ่ ลาดพร้าว 95",
    street: "61 ซอยลาดพร้าว 95 (ปรางค์ทิพย์)",
    locality: "แขวงคลองเจ้าคุณสิงห์ เขตวังทองหลาง",
    region: "กรุงเทพมหานคร",
    postalCode: "10310",
    geo: { lat: 13.7807, lng: 100.6019 },
    branchType: "hq",
    provinceSlug: "bangkok",
    districtSlug: "wang-thonglang",
    mapUrl: "https://maps.app.goo.gl/TxBckpUVn3gzepABA",
    landmarks: ["โรงพยาบาลลาดพร้าว", "ฟู้ดแลนด์ ลาดพร้าว", "บิ๊กซี ลาดพร้าว"],
    transit: ["MRT สายสีเหลือง สถานีมหาดไทย"],
    serviceFocus: ["notary", "translation", "sworn", "lgz", "moj", "pcc", "visa", "corporate", "estate", "apostille"],
    isHeadquarters: true,
    note: "ศูนย์กลางการดำเนินงานทุกบริการ รับเอกสารด่วนภายในวันเดียว",
  }),

  // ── ย่านศูนย์กลางการค้า / New CBD ──────────────────────────────
  branch({
    id: "bkk-centralworld",
    name: "จุดบริการเซ็นทรัลเวิลด์ (สยาม/ปทุมวัน)",
    shortName: "เซ็นทรัลเวิลด์",
    street: "",
    meetingPoint: "ศูนย์การค้าเซ็นทรัลเวิลด์ ย่านราชประสงค์-สยาม",
    locality: "แขวงปทุมวัน เขตปทุมวัน",
    region: "กรุงเทพมหานคร",
    postalCode: "10330",
    geo: { lat: 13.7466, lng: 100.5396 },
    serviceAreaOnly: true,
    branchType: "mall",
    provinceSlug: "bangkok",
    districtSlug: "pathum-wan",
    landmarks: ["ศาลพระพรหมเอราวัณ", "โรงพยาบาลตำรวจ"],
    transit: ["BTS ชิดลม", "BTS สยาม"],
    serviceFocus: ["notary", "translation", "sworn", "lgz", "visa", "apostille"],
  }),
  branch({
    id: "bkk-siam-paragon",
    name: "จุดบริการสยามพารากอน (สยาม/ปทุมวัน)",
    shortName: "สยามพารากอน",
    street: "",
    meetingPoint: "ศูนย์การค้าสยามพารากอน ย่านราชประสงค์-สยาม",
    locality: "แขวงปทุมวัน เขตปทุมวัน",
    region: "กรุงเทพมหานคร",
    postalCode: "10330",
    geo: { lat: 13.7462, lng: 100.5347 },
    serviceAreaOnly: true,
    branchType: "mall",
    provinceSlug: "bangkok",
    districtSlug: "pathum-wan",
    landmarks: ["สยามสแควร์", "จุฬาลงกรณ์มหาวิทยาลัย"],
    transit: ["BTS สยาม"],
    serviceFocus: ["notary", "translation", "sworn", "naati", "visa"],
  }),
  branch({
    id: "bkk-emsphere",
    name: "จุดบริการเอ็มสเฟียร์ (สุขุมวิท/พร้อมพงษ์)",
    shortName: "เอ็มสเฟียร์",
    street: "",
    meetingPoint: "ศูนย์การค้าเอ็มสเฟียร์ ถนนสุขุมวิท",
    locality: "แขวงคลองตัน เขตวัฒนา",
    region: "กรุงเทพมหานคร",
    postalCode: "10110",
    geo: { lat: 13.7301, lng: 100.5697 },
    serviceAreaOnly: true,
    branchType: "mall",
    provinceSlug: "bangkok",
    districtSlug: "watthana",
    landmarks: ["สวนเบญจสิริ", "ดิ เอ็มควอเทียร์"],
    transit: ["BTS พร้อมพงษ์"],
    serviceFocus: ["notary", "translation", "naati", "visa", "marriage"],
  }),
  branch({
    id: "bkk-terminal21-asok",
    name: "จุดบริการเทอร์มินอล 21 อโศก",
    shortName: "เทอร์มินอล 21 อโศก",
    street: "",
    meetingPoint: "เทอร์มินอล 21 อโศก ย่านสุขุมวิท",
    locality: "แขวงคลองเตยเหนือ เขตวัฒนา",
    region: "กรุงเทพมหานคร",
    postalCode: "10110",
    geo: { lat: 13.7376, lng: 100.5601 },
    serviceAreaOnly: true,
    branchType: "mall",
    provinceSlug: "bangkok",
    districtSlug: "watthana",
    landmarks: ["แยกอโศก", "มศว ประสานมิตร"],
    transit: ["BTS อโศก", "MRT สุขุมวิท"],
    serviceFocus: ["notary", "translation", "visa", "longstay", "marriage"],
  }),
  branch({
    id: "bkk-iconsiam",
    name: "จุดบริการไอคอนสยาม (เจริญนคร)",
    shortName: "ไอคอนสยาม",
    street: "",
    meetingPoint: "ไอคอนสยาม ซอยเจริญนคร",
    locality: "แขวงคลองต้นไทร เขตคลองสาน",
    region: "กรุงเทพมหานคร",
    postalCode: "10600",
    geo: { lat: 13.7263, lng: 100.5100 },
    serviceAreaOnly: true,
    branchType: "mall",
    provinceSlug: "bangkok",
    districtSlug: "khlong-san",
    landmarks: ["ท่าเรือเป๊ปซี่", "โรงพยาบาลตากสิน"],
    transit: ["BTS สายสีทอง สถานีเจริญนคร"],
    serviceFocus: ["notary", "translation", "lgz", "corporate"],
  }),
  branch({
    id: "bkk-central-rama9",
    name: "จุดบริการเซ็นทรัล พระราม 9 (New CBD)",
    shortName: "เซ็นทรัล พระราม 9",
    street: "",
    meetingPoint: "ศูนย์การค้าเซ็นทรัล พระราม 9 ถนนรัชดาภิเษก",
    locality: "แขวงห้วยขวาง เขตห้วยขวาง",
    region: "กรุงเทพมหานคร",
    postalCode: "10310",
    geo: { lat: 13.7580, lng: 100.5660 },
    serviceAreaOnly: true,
    branchType: "mall",
    provinceSlug: "bangkok",
    districtSlug: "huai-khwang",
    landmarks: ["ตึกจีทาวเวอร์", "ฟอร์จูนทาวน์", "สถานเอกอัครราชทูตจีน"],
    transit: ["MRT พระราม 9"],
    serviceFocus: ["notary", "translation", "visa", "corporate", "lgz"],
  }),
  branch({
    id: "bkk-central-eastville",
    name: "จุดบริการเซ็นทรัล อีสต์วิลล์ (เลียบด่วนรามอินทรา)",
    shortName: "เซ็นทรัล อีสต์วิลล์",
    street: "",
    meetingPoint: "ศูนย์การค้าเซ็นทรัล อีสต์วิลล์ ถนนประดิษฐ์มนูธรรม",
    locality: "แขวงลาดพร้าว เขตลาดพร้าว",
    region: "กรุงเทพมหานคร",
    postalCode: "10230",
    geo: { lat: 13.8060, lng: 100.6120 },
    serviceAreaOnly: true,
    branchType: "mall",
    provinceSlug: "bangkok",
    districtSlug: "lat-phrao",
    landmarks: ["โลตัส เลียบด่วนฯ", "คริสตัลพาร์ค"],
    transit: ["MRT สายสีเหลือง สถานีลาดพร้าว 71 (ต่อรถ)"],
    serviceFocus: ["notary", "translation", "estate", "civilreg"],
  }),

  // ── 48 เขตที่เหลือของกรุงเทพมหานคร ─────────────────────────────
  branch({
    id: "bkk-khlong-toei",
    name: "จุดบริการเขตคลองเตย",
    shortName: "คลองเตย",
    street: "",
    meetingPoint: "อาคารเอ็มโพเรียม ทาวเวอร์ ถนนสุขุมวิท",
    locality: "แขวงคลองเตย เขตคลองเตย",
    region: "กรุงเทพมหานคร",
    postalCode: "10110",
    geo: { lat: 13.7300, lng: 100.5690 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "khlong-toei",
    landmarks: ["สวนเบญจสิริ", "ดิ เอ็มโพเรียม"],
    transit: ["BTS พร้อมพงษ์"],
    serviceFocus: ["notary", "translation", "corporate", "visa"],
  }),
  branch({
    id: "bkk-khlong-san",
    name: "จุดบริการเขตคลองสาน",
    shortName: "คลองสาน",
    street: "",
    meetingPoint: "ไอคอนสยาม ซอยเจริญนคร",
    locality: "แขวงคลองต้นไทร เขตคลองสาน",
    region: "กรุงเทพมหานคร",
    postalCode: "10600",
    geo: { lat: 13.7265, lng: 100.5102 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "khlong-san",
    landmarks: ["โรงพยาบาลตากสิน", "ล้ง 1919"],
    transit: ["BTS สายสีทอง สถานีเจริญนคร"],
  }),
  branch({
    id: "bkk-khlong-sam-wa",
    name: "จุดบริการเขตคลองสามวา",
    shortName: "คลองสามวา",
    street: "",
    meetingPoint: "บิ๊กซี เอ็กซ์ตร้า สุวินทวงศ์ ถนนสุวินทวงศ์",
    locality: "แขวงทรายกองดิน เขตคลองสามวา",
    region: "กรุงเทพมหานคร",
    postalCode: "10510",
    geo: { lat: 13.8600, lng: 100.7280 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "khlong-sam-wa",
    landmarks: ["ตลาดมีนบุรี", "แยกมีนบุรี"],
    transit: ["MRT สายสีชมพู สถานีตลาดมีนบุรี"],
  }),
  branch({
    id: "bkk-khan-na-yao",
    name: "จุดบริการเขตคันนายาว",
    shortName: "คันนายาว",
    street: "",
    meetingPoint: "ศูนย์การค้าแฟชั่นไอส์แลนด์ ถนนรามอินทรา",
    locality: "แขวงคันนายาว เขตคันนายาว",
    region: "กรุงเทพมหานคร",
    postalCode: "10230",
    geo: { lat: 13.8250, lng: 100.6800 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "khan-na-yao",
    landmarks: ["พรอมานาด", "สวนสยาม"],
    transit: ["MRT สายสีชมพู สถานีวงแหวนรามอินทรา"],
  }),
  branch({
    id: "bkk-chatuchak",
    name: "จุดบริการเขตจตุจักร",
    shortName: "จตุจักร",
    street: "",
    meetingPoint: "ศูนย์การค้าเซ็นทรัล ลาดพร้าว ถนนพหลโยธิน",
    locality: "แขวงจตุจักร เขตจตุจักร",
    region: "กรุงเทพมหานคร",
    postalCode: "10900",
    geo: { lat: 13.8163, lng: 100.5601 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "chatuchak",
    landmarks: ["ยูเนี่ยนมอลล์", "สวนรถไฟ"],
    transit: ["BTS ห้าแยกลาดพร้าว", "MRT พหลโยธิน"],
    serviceFocus: ["notary", "translation", "corporate", "moj"],
  }),
  branch({
    id: "bkk-chom-thong",
    name: "จุดบริการเขตจอมทอง",
    shortName: "จอมทอง",
    street: "",
    meetingPoint: "ถนนสมเด็จพระเจ้าตากสิน",
    locality: "แขวงบุคคโล เขตจอมทอง",
    region: "กรุงเทพมหานคร",
    postalCode: "10600",
    geo: { lat: 13.7010, lng: 100.4860 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "chom-thong",
    landmarks: ["เดอะมอลล์ ท่าพระ", "ตลาดดาวคะนอง"],
    transit: ["BTS ตลาดพลู"],
  }),
  branch({
    id: "bkk-don-mueang",
    name: "จุดบริการเขตดอนเมือง (ท่าอากาศยานดอนเมือง)",
    shortName: "ดอนเมือง",
    street: "",
    meetingPoint: "ท่าอากาศยานดอนเมือง อาคารผู้โดยสารภายในประเทศ",
    locality: "แขวงสนามบิน เขตดอนเมือง",
    region: "กรุงเทพมหานคร",
    postalCode: "10210",
    geo: { lat: 13.9126, lng: 100.6068 },
    serviceAreaOnly: true,
    branchType: "airport",
    provinceSlug: "bangkok",
    districtSlug: "don-mueang",
    landmarks: ["กองทัพอากาศ", "ท่าอากาศยานดอนเมือง"],
    transit: ["SRT สายสีแดง สถานีดอนเมือง"],
    serviceFocus: ["notary", "translation", "visa", "immigration"],
  }),
  branch({
    id: "bkk-din-daeng",
    name: "จุดบริการเขตดินแดง",
    shortName: "ดินแดง",
    street: "",
    meetingPoint: "อาคารฟอร์จูนทาวน์ ถนนรัชดาภิเษก",
    locality: "แขวงดินแดง เขตดินแดง",
    region: "กรุงเทพมหานคร",
    postalCode: "10400",
    geo: { lat: 13.7570, lng: 100.5650 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "din-daeng",
    landmarks: ["เซ็นทรัล พระราม 9", "สถานเอกอัครราชทูตจีน"],
    transit: ["MRT พระราม 9"],
    serviceFocus: ["notary", "translation", "visa", "lgz"],
  }),
  branch({
    id: "bkk-dusit",
    name: "จุดบริการเขตดุสิต",
    shortName: "ดุสิต",
    street: "",
    meetingPoint: "อาคารศุภาลัย พรีมา ริวา ถนนสามเสน",
    locality: "แขวงถนนนครไชยศรี เขตดุสิต",
    region: "กรุงเทพมหานคร",
    postalCode: "10300",
    geo: { lat: 13.7840, lng: 100.5150 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "dusit",
    landmarks: ["รัฐสภาแห่งใหม่ (สัปปายะสภาสถาน)", "กรมชลประทาน"],
    transit: ["ท่าเรือพายัพ", "MRT บางโพ (ต่อรถ)"],
    serviceFocus: ["notary", "translation", "moj", "civilreg"],
  }),
  branch({
    id: "bkk-taling-chan",
    name: "จุดบริการเขตตลิ่งชัน",
    shortName: "ตลิ่งชัน",
    street: "",
    meetingPoint: "โครงการเดอะเซอร์เคิล ราชพฤกษ์ ถนนราชพฤกษ์",
    locality: "แขวงบางระมาด เขตตลิ่งชัน",
    region: "กรุงเทพมหานคร",
    postalCode: "10170",
    geo: { lat: 13.7770, lng: 100.4470 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "taling-chan",
    landmarks: ["ตลาดน้ำตลิ่งชัน", "สถานีขนส่งสายใต้ใหม่"],
    transit: ["SRT สายสีแดงอ่อน สถานีตลิ่งชัน"],
  }),
  branch({
    id: "bkk-thawi-watthana",
    name: "จุดบริการเขตทวีวัฒนา",
    shortName: "ทวีวัฒนา",
    street: "",
    meetingPoint: "หมู่บ้านกรีนวิลล์ ถนนบรมราชชนนี",
    locality: "แขวงศาลาธรรมสพน์ เขตทวีวัฒนา",
    region: "กรุงเทพมหานคร",
    postalCode: "10170",
    geo: { lat: 13.7770, lng: 100.3630 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "thawi-watthana",
    landmarks: ["พุทธมณฑล", "ตลาดเวิลด์มาร์เก็ต"],
    transit: ["ใกล้ถนนพุทธมณฑลสาย 2"],
  }),
  branch({
    id: "bkk-thung-khru",
    name: "จุดบริการเขตทุ่งครุ",
    shortName: "ทุ่งครุ",
    street: "",
    meetingPoint: "ถนนประชาอุทิศ",
    locality: "แขวงบางมด เขตทุ่งครุ",
    region: "กรุงเทพมหานคร",
    postalCode: "10140",
    geo: { lat: 13.6480, lng: 100.4970 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "thung-khru",
    landmarks: ["มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี (บางมด)", "ตลาดทุ่งครุ 61"],
    transit: ["ใกล้ทางด่วนวงแหวนอุตสาหกรรม"],
  }),
  branch({
    id: "bkk-thon-buri",
    name: "จุดบริการเขตธนบุรี",
    shortName: "ธนบุรี",
    street: "",
    meetingPoint: "โครงการเสริมศุข พลาซ่า ถนนสมเด็จพระเจ้าตากสิน",
    locality: "แขวงบุคคโล เขตธนบุรี",
    region: "กรุงเทพมหานคร",
    postalCode: "10600",
    geo: { lat: 13.7200, lng: 100.4880 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "thon-buri",
    landmarks: ["โรงพยาบาลสมเด็จพระปิ่นเกล้า", "สะพานตากสิน"],
    transit: ["BTS วงเวียนใหญ่"],
  }),
  branch({
    id: "bkk-bangkok-noi",
    name: "จุดบริการเขตบางกอกน้อย",
    shortName: "บางกอกน้อย",
    street: "",
    meetingPoint: "ศูนย์การค้าเซ็นทรัล ปิ่นเกล้า ถนนบรมราชชนนี",
    locality: "แขวงอรุณอมรินทร์ เขตบางกอกน้อย",
    region: "กรุงเทพมหานคร",
    postalCode: "10700",
    geo: { lat: 13.7770, lng: 100.4770 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "bangkok-noi",
    landmarks: ["เมเจอร์ ปิ่นเกล้า", "โรงพยาบาลศิริราช"],
    transit: ["MRT บางยี่ขัน"],
  }),
  branch({
    id: "bkk-bangkok-yai",
    name: "จุดบริการเขตบางกอกใหญ่",
    shortName: "บางกอกใหญ่",
    street: "",
    meetingPoint: "ถนนอรุณอมรินทร์",
    locality: "แขวงวัดอรุณ เขตบางกอกใหญ่",
    region: "กรุงเทพมหานคร",
    postalCode: "10600",
    geo: { lat: 13.7420, lng: 100.4870 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "bangkok-yai",
    landmarks: ["วัดอรุณราชวราราม", "หอประชุมกองทัพเรือ"],
    transit: ["MRT อิสรภาพ"],
  }),
  branch({
    id: "bkk-bang-kapi",
    name: "จุดบริการเขตบางกะปิ",
    shortName: "บางกะปิ",
    street: "",
    meetingPoint: "เดอะมอลล์ไลฟ์สโตร์ บางกะปิ ถนนลาดพร้าว",
    locality: "แขวงคลองจั่น เขตบางกะปิ",
    region: "กรุงเทพมหานคร",
    postalCode: "10240",
    geo: { lat: 13.7650, lng: 100.6440 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "bang-kapi",
    landmarks: ["ตลาดบางกะปิ", "มหาวิทยาลัยรามคำแหง"],
    transit: ["MRT สายสีเหลือง สถานีบางกะปิ"],
  }),
  branch({
    id: "bkk-bang-khun-thian",
    name: "จุดบริการเขตบางขุนเทียน",
    shortName: "บางขุนเทียน",
    street: "",
    meetingPoint: "ย่านราชประสงค์-สยาม",
    locality: "แขวงแสมดำ เขตบางขุนเทียน",
    region: "กรุงเทพมหานคร",
    postalCode: "10150",
    geo: { lat: 13.6600, lng: 100.4400 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "bang-khun-thian",
    landmarks: ["เซ็นทรัล พระราม 2", "โรงพยาบาลนครธน"],
    transit: ["ใกล้ทางด่วนพระราม 2"],
  }),
  branch({
    id: "bkk-bang-khen",
    name: "จุดบริการเขตบางเขน",
    shortName: "บางเขน",
    street: "",
    meetingPoint: "ถนนพหลโยธิน",
    locality: "แขวงอนุสาวรีย์ เขตบางเขน",
    region: "กรุงเทพมหานคร",
    postalCode: "10220",
    geo: { lat: 13.8740, lng: 100.5960 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "bang-khen",
    landmarks: ["วัดพระศรีมหาธาตุ", "วงเวียนบางเขน"],
    transit: ["BTS วัดพระศรีมหาธาตุ"],
  }),
  branch({
    id: "bkk-bang-kho-laem",
    name: "จุดบริการเขตบางคอแหลม",
    shortName: "บางคอแหลม",
    street: "",
    meetingPoint: "เทอร์มินอล 21 พระราม 3",
    locality: "แขวงบางคอแหลม เขตบางคอแหลม",
    region: "กรุงเทพมหานคร",
    postalCode: "10120",
    geo: { lat: 13.6930, lng: 100.5140 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "bang-kho-laem",
    landmarks: ["เอเชียทีค เดอะ ริเวอร์ฟร้อนท์", "สะพานกรุงเทพ"],
    transit: ["BRT เจริญราษฎร์"],
  }),
  branch({
    id: "bkk-bang-khae",
    name: "จุดบริการเขตบางแค",
    shortName: "บางแค",
    street: "",
    meetingPoint: "เดอะมอลล์ บางแค ถนนเพชรเกษม",
    locality: "แขวงบางแคเหนือ เขตบางแค",
    region: "กรุงเทพมหานคร",
    postalCode: "10160",
    geo: { lat: 13.7160, lng: 100.4090 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "bang-khae",
    landmarks: ["ตลาดบางแค", "ซีคอน บางแค"],
    transit: ["MRT หลักสอง"],
  }),
  branch({
    id: "bkk-bang-sue",
    name: "จุดบริการเขตบางซื่อ (สถานีกลางกรุงเทพอภิวัฒน์)",
    shortName: "บางซื่อ",
    street: "",
    meetingPoint: "โครงการเกตเวย์ แอท บางซื่อ ถนนประชาราษฎร์",
    locality: "แขวงบางซื่อ เขตบางซื่อ",
    region: "กรุงเทพมหานคร",
    postalCode: "10800",
    geo: { lat: 13.8020, lng: 100.5350 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "bang-sue",
    landmarks: ["สถานีกลางกรุงเทพอภิวัฒน์", "โรงพยาบาลบางโพ", "สถานีขนส่งหมอชิต 2"],
    transit: ["MRT บางโพ", "MRT บางซื่อ", "SRT สายสีแดง"],
    serviceFocus: ["notary", "translation", "visa", "corporate"],
  }),
  branch({
    id: "bkk-bang-na",
    name: "จุดบริการเขตบางนา",
    shortName: "บางนา",
    street: "",
    meetingPoint: "อาคารบางนา ทาวเวอร์ A ถนนเทพรัตน",
    locality: "แขวงบางนาเหนือ เขตบางนา",
    region: "กรุงเทพมหานคร",
    postalCode: "10260",
    geo: { lat: 13.6680, lng: 100.6100 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "bang-na",
    landmarks: ["เซ็นทรัล บางนา", "ไบเทค บางนา", "โรงเรียนนานาชาติ Bangkok Patana"],
    transit: ["BTS บางนา (ต่อรถ)"],
    serviceFocus: ["notary", "translation", "naati", "visa", "corporate"],
  }),
  branch({
    id: "bkk-bang-bon",
    name: "จุดบริการเขตบางบอน",
    shortName: "บางบอน",
    street: "",
    meetingPoint: "ถนนเอกชัย",
    locality: "แขวงบางบอนใต้ เขตบางบอน",
    region: "กรุงเทพมหานคร",
    postalCode: "10150",
    geo: { lat: 13.6690, lng: 100.4000 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "bang-bon",
    landmarks: ["แม็คโคร บางบอน", "ตลาดสดศิริชัย"],
    transit: ["รถไฟสายมหาชัย สถานีบางบอน"],
  }),
  branch({
    id: "bkk-bang-phlat",
    name: "จุดบริการเขตบางพลัด",
    shortName: "บางพลัด",
    street: "",
    meetingPoint: "ตั้งฮั่วเส็ง ธนบุรี ถนนสิรินธร",
    locality: "แขวงบางบำหรุ เขตบางพลัด",
    region: "กรุงเทพมหานคร",
    postalCode: "10700",
    geo: { lat: 13.7830, lng: 100.4770 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "bang-phlat",
    landmarks: ["ช่างชุ่ย", "มหาวิทยาลัยสวนดุสิต ศูนย์สิรินธร"],
    transit: ["MRT สิรินธร"],
  }),
  branch({
    id: "bkk-bang-rak",
    name: "จุดบริการเขตบางรัก (สีลม)",
    shortName: "บางรัก / สีลม",
    street: "",
    meetingPoint: "อาคารยูไนเต็ด เซ็นเตอร์ ถนนสีลม",
    locality: "แขวงสีลม เขตบางรัก",
    region: "กรุงเทพมหานคร",
    postalCode: "10500",
    geo: { lat: 13.7280, lng: 100.5340 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "bang-rak",
    landmarks: ["โรงพยาบาลกรุงเทพคริสเตียน", "สวนลุมพินี", "ศูนย์ยื่นวีซ่าสเปน BLS"],
    transit: ["BTS ศาลาแดง", "MRT สีลม"],
    serviceFocus: ["notary", "translation", "sworn", "visa", "corporate", "lgz"],
  }),
  branch({
    id: "bkk-bueng-kum",
    name: "จุดบริการเขตบึงกุ่ม",
    shortName: "บึงกุ่ม",
    street: "",
    meetingPoint: "ถนนประเสริฐมนูกิจ (เกษตร-นวมินทร์)",
    locality: "แขวงนวมินทร์ เขตบึงกุ่ม",
    region: "กรุงเทพมหานคร",
    postalCode: "10240",
    geo: { lat: 13.8000, lng: 100.6500 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "bueng-kum",
    landmarks: ["ตลาดหัวมุม", "ช็อกโกแลตวิลล์"],
    transit: ["ใกล้ทางด่วนรามอินทรา-อาจณรงค์"],
  }),
  branch({
    id: "bkk-prawet",
    name: "จุดบริการเขตประเวศ",
    shortName: "ประเวศ",
    street: "",
    meetingPoint: "ศูนย์การค้าพาราไดซ์ พาร์ค ถนนศรีนครินทร์",
    locality: "แขวงหนองบอน เขตประเวศ",
    region: "กรุงเทพมหานคร",
    postalCode: "10250",
    geo: { lat: 13.6900, lng: 100.6470 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "prawet",
    landmarks: ["สวนหลวง ร.9", "ซีคอนสแควร์"],
    transit: ["MRT สายสีเหลือง สถานีสวนหลวง ร.9"],
  }),
  branch({
    id: "bkk-pom-prap",
    name: "จุดบริการเขตป้อมปราบศัตรูพ่าย",
    shortName: "ป้อมปราบฯ",
    street: "",
    meetingPoint: "ถนนหลวง",
    locality: "แขวงป้อมปราบ เขตป้อมปราบศัตรูพ่าย",
    region: "กรุงเทพมหานคร",
    postalCode: "10100",
    geo: { lat: 13.7480, lng: 100.5130 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "pom-prap-sattru-phai",
    landmarks: ["โรงพยาบาลกลาง", "คลองถม", "วัดมังกรกมลาวาส"],
    transit: ["MRT วัดมังกร"],
  }),
  branch({
    id: "bkk-phaya-thai",
    name: "จุดบริการเขตพญาไท (อารีย์)",
    shortName: "พญาไท / อารีย์",
    street: "",
    meetingPoint: "อาคารพหลโยธินเพลส ถนนพหลโยธิน",
    locality: "แขวงสามเสนใน เขตพญาไท",
    region: "กรุงเทพมหานคร",
    postalCode: "10400",
    geo: { lat: 13.7800, lng: 100.5440 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "phaya-thai",
    landmarks: ["วิลล่ามาร์เก็ต อารีย์", "โรงพยาบาลวิมุต"],
    transit: ["BTS อารีย์"],
  }),
  branch({
    id: "bkk-phra-khanong",
    name: "จุดบริการเขตพระโขนง (ทรู ดิจิทัล พาร์ค)",
    shortName: "พระโขนง",
    street: "",
    meetingPoint: "อาคารทรู ดิจิทัล พาร์ค ถนนสุขุมวิท",
    locality: "แขวงบางจาก เขตพระโขนง",
    region: "กรุงเทพมหานคร",
    postalCode: "10260",
    geo: { lat: 13.6800, lng: 100.6090 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "phra-khanong",
    landmarks: ["ปุณณวิถี", "วัดธรรมมงคล"],
    transit: ["BTS ปุณณวิถี"],
    serviceFocus: ["notary", "translation", "corporate", "visa"],
  }),
  branch({
    id: "bkk-phra-nakhon",
    name: "จุดบริการเขตพระนคร (บางลำพู)",
    shortName: "พระนคร",
    street: "",
    meetingPoint: "ถนนจักรพงษ์",
    locality: "แขวงชนะสงคราม เขตพระนคร",
    region: "กรุงเทพมหานคร",
    postalCode: "10200",
    geo: { lat: 13.7600, lng: 100.4970 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "phra-nakhon",
    landmarks: ["ถนนข้าวสาร", "บางลำพู", "วัดบวรนิเวศวิหาร"],
    transit: ["ท่าเรือพระอาทิตย์", "MRT สามยอด (ต่อรถ)"],
    serviceFocus: ["notary", "translation", "visa", "marriage"],
  }),
  branch({
    id: "bkk-phasi-charoen",
    name: "จุดบริการเขตภาษีเจริญ",
    shortName: "ภาษีเจริญ",
    street: "",
    meetingPoint: "ศูนย์การค้าซีคอน บางแค ถนนเพชรเกษม",
    locality: "แขวงบางหว้า เขตภาษีเจริญ",
    region: "กรุงเทพมหานคร",
    postalCode: "10160",
    geo: { lat: 13.7200, lng: 100.4400 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "phasi-charoen",
    landmarks: ["มหาวิทยาลัยสยาม", "โรงพยาบาลพญาไท 3"],
    transit: ["MRT ภาษีเจริญ"],
  }),
  branch({
    id: "bkk-min-buri",
    name: "จุดบริการเขตมีนบุรี",
    shortName: "มีนบุรี",
    street: "",
    meetingPoint: "โลตัส มีนบุรี ถนนสีหบุรานุกิจ",
    locality: "แขวงมีนบุรี เขตมีนบุรี",
    region: "กรุงเทพมหานคร",
    postalCode: "10510",
    geo: { lat: 13.8140, lng: 100.7300 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "min-buri",
    landmarks: ["ศาลจังหวัดมีนบุรี", "ตลาดมีนบุรี"],
    transit: ["MRT สายสีชมพู สถานีตลาดมีนบุรี"],
    serviceFocus: ["notary", "translation", "moj", "civilreg"],
  }),
  branch({
    id: "bkk-yan-nawa",
    name: "จุดบริการเขตยานนาวา",
    shortName: "ยานนาวา",
    street: "",
    meetingPoint: "อาคารสำนักงานเซ็นทรัล พระราม 9 ถนนรัชดาภิเษก",
    locality: "แขวงช่องนนทรี เขตยานนาวา",
    region: "กรุงเทพมหานคร",
    postalCode: "10120",
    geo: { lat: 13.6870, lng: 100.5400 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "yan-nawa",
    landmarks: ["โลตัส พระราม 3", "ตลาดรุ่งเจริญ"],
    transit: ["BRT ถนนจันทน์"],
  }),
  branch({
    id: "bkk-ratchathewi",
    name: "จุดบริการเขตราชเทวี (อนุสาวรีย์ชัยฯ)",
    shortName: "ราชเทวี",
    street: "",
    meetingPoint: "อาคารเซ็นจูรี่ เดอะมูฟวี่ พลาซ่า ถนนพญาไท",
    locality: "แขวงถนนพญาไท เขตราชเทวี",
    region: "กรุงเทพมหานคร",
    postalCode: "10400",
    geo: { lat: 13.7650, lng: 100.5380 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "ratchathewi",
    landmarks: ["อนุสาวรีย์ชัยสมรภูมิ", "คิง เพาเวอร์ รางน้ำ"],
    transit: ["BTS อนุสาวรีย์ชัยสมรภูมิ"],
  }),
  branch({
    id: "bkk-rat-burana",
    name: "จุดบริการเขตราษฎร์บูรณะ",
    shortName: "ราษฎร์บูรณะ",
    street: "",
    meetingPoint: "ถนนราษฎร์บูรณะ",
    locality: "แขวงราษฎร์บูรณะ เขตราษฎร์บูรณะ",
    region: "กรุงเทพมหานคร",
    postalCode: "10140",
    geo: { lat: 13.6790, lng: 100.5050 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "rat-burana",
    landmarks: ["สำนักงานใหญ่ธนาคารกสิกรไทย", "บิ๊กซี บางปะกอก"],
    transit: ["ใกล้ทางด่วนเฉลิมมหานคร"],
  }),
  branch({
    id: "bkk-lat-krabang",
    name: "จุดบริการเขตลาดกระบัง (สุวรรณภูมิ)",
    shortName: "ลาดกระบัง",
    street: "",
    meetingPoint: "โครงการโรบินสัน ไลฟ์สไตล์ ลาดกระบัง ถนนลาดกระบัง",
    locality: "แขวงลาดกระบัง เขตลาดกระบัง",
    region: "กรุงเทพมหานคร",
    postalCode: "10520",
    geo: { lat: 13.7220, lng: 100.7800 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "lat-krabang",
    landmarks: ["ท่าอากาศยานสุวรรณภูมิ", "สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง"],
    transit: ["ARL ลาดกระบัง"],
    serviceFocus: ["notary", "translation", "visa", "immigration", "corporate"],
  }),
  branch({
    id: "bkk-lat-phrao",
    name: "จุดบริการเขตลาดพร้าว (เดอะคริสตัล)",
    shortName: "ลาดพร้าว",
    street: "",
    meetingPoint: "โครงการเดอะคริสตัล เอกมัย-รามอินทรา ถนนประดิษฐ์มนูธรรม",
    locality: "แขวงลาดพร้าว เขตลาดพร้าว",
    region: "กรุงเทพมหานคร",
    postalCode: "10230",
    geo: { lat: 13.8050, lng: 100.6110 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "lat-phrao",
    landmarks: ["เซ็นทรัล อีสต์วิลล์", "CDC Crystal Design Center"],
    transit: ["ทางด่วนเอกมัย-รามอินทรา"],
  }),
  branch({
    id: "bkk-watthana-thonglor",
    name: "จุดบริการเขตวัฒนา (ทองหล่อ)",
    shortName: "วัฒนา / ทองหล่อ",
    street: "",
    meetingPoint: "ซอยสุขุมวิท (ทองหล่อ)",
    locality: "แขวงคลองตันเหนือ เขตวัฒนา",
    region: "กรุงเทพมหานคร",
    postalCode: "10110",
    geo: { lat: 13.7330, lng: 100.5820 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "watthana",
    landmarks: ["เจ อเวนิว ทองหล่อ", "โรงพยาบาลคามิลเลียน", "โรงพยาบาลสมิติเวช สุขุมวิท", "ชุมชนชาวญี่ปุ่น"],
    transit: ["BTS ทองหล่อ"],
    serviceFocus: ["notary", "translation", "sworn", "visa", "marriage", "longstay"],
    note: "รองรับการแปลเอกสารทะเบียนราษฎร์ญี่ปุ่น (Koseki Tohon) และเอกสารครอบครัวชาวญี่ปุ่น",
  }),
  branch({
    id: "bkk-suan-luang",
    name: "จุดบริการเขตสวนหลวง",
    shortName: "สวนหลวง",
    street: "",
    meetingPoint: "โครงการธัญญาพาร์ค ถนนศรีนครินทร์",
    locality: "แขวงสวนหลวง เขตสวนหลวง",
    region: "กรุงเทพมหานคร",
    postalCode: "10250",
    geo: { lat: 13.7250, lng: 100.6440 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "suan-luang",
    landmarks: ["เตรียมอุดมศึกษาพัฒนาการ", "แม็กซ์แวลู พัฒนาการ"],
    transit: ["MRT สายสีเหลือง สถานีกลันตัน", "ARL หัวหมาก"],
  }),
  branch({
    id: "bkk-saphan-sung",
    name: "จุดบริการเขตสะพานสูง",
    shortName: "สะพานสูง",
    street: "",
    meetingPoint: "โครงการสัมมากรเพลส รามคำแหง ถนนรามคำแหง",
    locality: "แขวงสะพานสูง เขตสะพานสูง",
    region: "กรุงเทพมหานคร",
    postalCode: "10240",
    geo: { lat: 13.7700, lng: 100.6870 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "saphan-sung",
    landmarks: ["หมู่บ้านสัมมากร", "โรงพยาบาลเกษมราษฎร์ รามคำแหง"],
    transit: ["MRT สายสีส้ม สถานีสัมมากร (โครงการอนาคต)"],
  }),
  branch({
    id: "bkk-samphanthawong",
    name: "จุดบริการเขตสัมพันธวงศ์ (เยาวราช)",
    shortName: "สัมพันธวงศ์",
    street: "",
    meetingPoint: "ถนนเยาวราช",
    locality: "แขวงสัมพันธวงศ์ เขตสัมพันธวงศ์",
    region: "กรุงเทพมหานคร",
    postalCode: "10100",
    geo: { lat: 13.7400, lng: 100.5100 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "samphanthawong",
    landmarks: ["ซุ้มประตูเฉลิมพระเกียรติ วงเวียนโอเดียน", "วัดไตรมิตร"],
    transit: ["MRT วัดมังกร", "MRT หัวลำโพง"],
    serviceFocus: ["notary", "translation", "corporate", "lgz"],
  }),
  branch({
    id: "bkk-sathon",
    name: "จุดบริการเขตสาทร (สาทร สแควร์)",
    shortName: "สาทร",
    street: "",
    meetingPoint: "อาคารสาทร สแควร์ ถนนสาทรเหนือ",
    locality: "แขวงสีลม เขตบางรัก",
    region: "กรุงเทพมหานคร",
    postalCode: "10500",
    geo: { lat: 13.7230, lng: 100.5290 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "sathon",
    landmarks: ["ตึกเอ็มไพร์ทาวเวอร์", "โรงพยาบาลเซนต์หลุยส์", "สถานเอกอัครราชทูตออสเตรเลีย/สิงคโปร์"],
    transit: ["BTS ช่องนนทรี", "BRT สาทร"],
    serviceFocus: ["notary", "translation", "sworn", "naati", "lgz", "corporate", "visa"],
    note: "ใกล้สถานเอกอัครราชทูตหลายแห่ง เหมาะกับงานรับรองเอกสารเพื่อยื่นสถานทูตโดยตรง",
  }),
  branch({
    id: "bkk-sai-mai",
    name: "จุดบริการเขตสายไหม",
    shortName: "สายไหม",
    street: "",
    meetingPoint: "ถนนสุขาภิบาล 5",
    locality: "แขวงออเงิน เขตสายไหม",
    region: "กรุงเทพมหานคร",
    postalCode: "10220",
    geo: { lat: 13.9130, lng: 100.6570 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "sai-mai",
    landmarks: ["ตลาดออเงิน", "สำนักงานเขตสายไหม"],
    transit: ["ใกล้ทางด่วนสุขาภิบาล 5"],
  }),
  branch({
    id: "bkk-nong-khaem",
    name: "จุดบริการเขตหนองแขม",
    shortName: "หนองแขม",
    street: "",
    meetingPoint: "ถนนเพชรเกษม",
    locality: "แขวงหนองแขม เขตหนองแขม",
    region: "กรุงเทพมหานคร",
    postalCode: "10160",
    geo: { lat: 13.7050, lng: 100.3490 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "nong-khaem",
    landmarks: ["มหาวิทยาลัยเอเชียอาคเนย์", "โรงพยาบาลวิชัยเวช"],
    transit: ["ใกล้พุทธมณฑลสาย 3"],
  }),
  branch({
    id: "bkk-nong-chok",
    name: "จุดบริการเขตหนองจอก",
    shortName: "หนองจอก",
    street: "",
    meetingPoint: "บิ๊กซี หนองจอก ถนนเชื่อมสัมพันธ์",
    locality: "แขวงกระทุ่มราย เขตหนองจอก",
    region: "กรุงเทพมหานคร",
    postalCode: "10530",
    geo: { lat: 13.8560, lng: 100.8620 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "nong-chok",
    landmarks: ["มหาวิทยาลัยเทคโนโลยีมหานคร", "สำนักงานเขตหนองจอก"],
    transit: ["ถนนสุวินทวงศ์"],
  }),
  branch({
    id: "bkk-lak-si",
    name: "จุดบริการเขตหลักสี่ (ไอที สแควร์)",
    shortName: "หลักสี่",
    street: "",
    meetingPoint: "ไอที สแควร์ หลักสี่ ถนนแจ้งวัฒนะ",
    locality: "แขวงตลาดบางเขน เขตหลักสี่",
    region: "กรุงเทพมหานคร",
    postalCode: "10210",
    geo: { lat: 13.8850, lng: 100.5730 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "lak-si",
    landmarks: ["ศูนย์ราชการแจ้งวัฒนะ", "วัดหลักสี่"],
    transit: ["MRT สายสีชมพู สถานีหลักสี่", "SRT สายสีแดง"],
    serviceFocus: ["notary", "translation", "lgz", "moj", "pcc", "apostille"],
  }),
  branch({
    id: "bkk-huai-khwang",
    name: "จุดบริการเขตห้วยขวาง (G Tower)",
    shortName: "ห้วยขวาง",
    street: "",
    meetingPoint: "อาคาร G Tower ถนนพระรามที่ 1",
    locality: "แขวงห้วยขวาง เขตห้วยขวาง",
    region: "กรุงเทพมหานคร",
    postalCode: "10310",
    geo: { lat: 13.7570, lng: 100.5670 },
    serviceAreaOnly: true,
    branchType: "district",
    provinceSlug: "bangkok",
    districtSlug: "huai-khwang",
    landmarks: ["เซ็นทรัล พระราม 9", "ฟอร์จูนทาวน์", "ตลาดห้วยขวาง (New Chinatown)"],
    transit: ["MRT พระราม 9", "MRT ห้วยขวาง"],
    serviceFocus: ["notary", "translation", "visa", "corporate", "lgz"],
    note: "รองรับงานแปลไทย-จีนและเอกสารจัดตั้งบริษัทไทย-จีนย่านห้วยขวาง",
  }),
];
